AFRAME.registerComponent('news-graph-legend-vr', {
    init: function () {
        this.render = this.render.bind(this);
        this.render();

        this.el.sceneEl.addEventListener('theme-changed', this.render);
    },
    remove: function () {
        this.el.sceneEl.removeEventListener('theme-changed', this.render);
    },
    _isLightMode: function() {
        if (typeof getCacheItem === 'function') {
            const settings = getCacheItem('mainSettings');
            if (settings && settings.themeMode) {
                return settings.themeMode === 'Light';
            }
        }
        return false;
    },
    render: function () {
        this.el.innerHTML = '';

        const isLight = this._isLightMode();
        const panelColor = isLight ? '#F5F5F5' : '#111';
        const textColor = isLight ? '#111827' : '#ffffff';
        const subtextColor = isLight ? '#6b7280' : '#9ca3af';
        const dividerColor = isLight ? '#e5e7eb' : '#374151';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 0.65);
        bg.setAttribute('height', 1.45);
        bg.setAttribute('position', '-0.325 -0.725 0');
        bg.setAttribute('color', panelColor);
        bg.setAttribute('radius', 0.03);
        this.el.appendChild(bg);

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Legend');
        title.setAttribute('font-size', '0.05');
        title.setAttribute('font-weight', 'bold');
        title.setAttribute('align', 'center');
        title.setAttribute('anchor', 'center');
        title.setAttribute('position', '0.325 1.37 0.01');
        title.setAttribute('color', textColor);
        bg.appendChild(title);

        const createDivider = (y) => {
            const div = document.createElement('a-plane');
            div.setAttribute('width', 0.55);
            div.setAttribute('height', 0.002);
            div.setAttribute('color', dividerColor);
            div.setAttribute('position', `0.325 ${y} 0.01`);
            bg.appendChild(div);
        };

        const narCircle = document.createElement('a-circle');
        narCircle.setAttribute('radius', 0.015);
        narCircle.setAttribute('color', subtextColor);
        narCircle.setAttribute('position', '0.06 1.25 0.01');
        bg.appendChild(narCircle);

        const narTitle = document.createElement('a-troika-text');
        narTitle.setAttribute('value', 'Narrative (Topic)');
        narTitle.setAttribute('font-size', '0.035');
        narTitle.setAttribute('font-weight', 'bold');
        narTitle.setAttribute('align', 'left');
        narTitle.setAttribute('anchor', 'left');
        narTitle.setAttribute('position', '0.10 1.25 0.01');
        narTitle.setAttribute('color', textColor);
        bg.appendChild(narTitle);

        const narSubtitle = document.createElement('a-troika-text');
        narSubtitle.setAttribute('value', 'Color = Sentiment');
        narSubtitle.setAttribute('font-size', '0.026');
        narSubtitle.setAttribute('align', 'left');
        narSubtitle.setAttribute('anchor', 'left');
        narSubtitle.setAttribute('position', '0.10 1.20 0.01');
        narSubtitle.setAttribute('color', subtextColor);
        bg.appendChild(narSubtitle);

        const sentiments = [
            { label: 'Bullish', color: '#00ff00', y: 1.13 },
            { label: 'Bearish', color: '#ff0000', y: 1.06 },
            { label: 'Mixed', color: '#ffff00', y: 0.99 },
            { label: 'Neutral', color: '#aaaaaa', y: 0.92 }
        ];
        sentiments.forEach(item => {
            const circle = document.createElement('a-circle');
            circle.setAttribute('radius', 0.01);
            circle.setAttribute('color', item.color);
            circle.setAttribute('position', `0.10 ${item.y} 0.01`);
            bg.appendChild(circle);

            const text = document.createElement('a-troika-text');
            text.setAttribute('value', item.label);
            text.setAttribute('font-size', '0.03');
            text.setAttribute('align', 'left');
            text.setAttribute('anchor', 'left');
            text.setAttribute('position', `0.15 ${item.y} 0.01`);
            text.setAttribute('color', textColor);
            bg.appendChild(text);
        });

        createDivider(0.86);

        const tickTri = document.createElement('a-triangle');
        tickTri.setAttribute('vertex-a', '0 0.015 0');
        tickTri.setAttribute('vertex-b', '-0.012 -0.015 0');
        tickTri.setAttribute('vertex-c', '0.012 -0.015 0');
        tickTri.setAttribute('color', subtextColor);
        tickTri.setAttribute('position', '0.06 0.79 0.01');
        bg.appendChild(tickTri);

        const tickTitle = document.createElement('a-troika-text');
        tickTitle.setAttribute('value', 'Ticker (Stock)');
        tickTitle.setAttribute('font-size', '0.035');
        tickTitle.setAttribute('font-weight', 'bold');
        tickTitle.setAttribute('align', 'left');
        tickTitle.setAttribute('anchor', 'left');
        tickTitle.setAttribute('position', '0.10 0.79 0.01');
        tickTitle.setAttribute('color', textColor);
        bg.appendChild(tickTitle);

        const tickSubtitle = document.createElement('a-troika-text');
        tickSubtitle.setAttribute('value', "Color = Today's Price Change");
        tickSubtitle.setAttribute('font-size', '0.026');
        tickSubtitle.setAttribute('align', 'left');
        tickSubtitle.setAttribute('anchor', 'left');
        tickSubtitle.setAttribute('position', '0.10 0.74 0.01');
        tickSubtitle.setAttribute('color', subtextColor);
        bg.appendChild(tickSubtitle);

        const priceChanges = [
            { label: '>= +1%', color: '#00ff00', y: 0.67 },
            { label: '<= -1%', color: '#ff0000', y: 0.60 },
            { label: 'Within +-1%', color: '#ffff00', y: 0.53 },
            { label: 'No data', color: '#aaaaaa', y: 0.46 }
        ];
        priceChanges.forEach(item => {
            const circle = document.createElement('a-circle');
            circle.setAttribute('radius', 0.01);
            circle.setAttribute('color', item.color);
            circle.setAttribute('position', `0.10 ${item.y} 0.01`);
            bg.appendChild(circle);

            const text = document.createElement('a-troika-text');
            text.setAttribute('value', item.label);
            text.setAttribute('font-size', '0.03');
            text.setAttribute('align', 'left');
            text.setAttribute('anchor', 'left');
            text.setAttribute('position', `0.15 ${item.y} 0.01`);
            text.setAttribute('color', textColor);
            bg.appendChild(text);
        });

        createDivider(0.40);

        const glowTitle = document.createElement('a-troika-text');
        glowTitle.setAttribute('value', 'Glow');
        glowTitle.setAttribute('font-size', '0.035');
        glowTitle.setAttribute('font-weight', 'bold');
        glowTitle.setAttribute('align', 'left');
        glowTitle.setAttribute('anchor', 'left');
        glowTitle.setAttribute('position', '0.06 0.33 0.01');
        glowTitle.setAttribute('color', textColor);
        bg.appendChild(glowTitle);

        const glowNote = document.createElement('a-troika-text');
        glowNote.setAttribute('value', 'New topics (or change in Inflection)');
        glowNote.setAttribute('font-size', '0.024');
        glowNote.setAttribute('align', 'left');
        glowNote.setAttribute('anchor', 'left');
        glowNote.setAttribute('position', '0.06 0.28 0.01');
        glowNote.setAttribute('max-width', '0.53');
        glowNote.setAttribute('color', subtextColor);
        bg.appendChild(glowNote);

        createDivider(0.22);

        const infoSize = document.createElement('a-troika-text');
        infoSize.setAttribute('value', 'Size: number of articles\n(news topics are scaled 2X larger than tickers)');
        infoSize.setAttribute('font-size', '0.024');
        infoSize.setAttribute('align', 'left');
        infoSize.setAttribute('anchor', 'left');
        infoSize.setAttribute('position', '0.06 0.15 0.01');
        infoSize.setAttribute('max-width', '0.53');
        infoSize.setAttribute('color', subtextColor);
        bg.appendChild(infoSize);

        const infoLines = document.createElement('a-troika-text');
        infoLines.setAttribute('value', 'Line width = # of cross-mentions');
        infoLines.setAttribute('font-size', '0.024');
        infoLines.setAttribute('align', 'left');
        infoLines.setAttribute('anchor', 'left');
        infoLines.setAttribute('position', '0.06 0.06 0.01');
        infoLines.setAttribute('max-width', '0.53');
        infoLines.setAttribute('color', subtextColor);
        bg.appendChild(infoLines);

        const mainSettings = document.querySelector('#main-settings-popup')?.components['main-settings'];
        const isRepositioning = mainSettings ? mainSettings.isRepositioning : false;

        const handle = document.createElement('a-rounded-box');
        handle.setAttribute('id', 'move-legend-panel-area');
        handle.setAttribute('width', '0.56');
        handle.setAttribute('height', '0.054');
        handle.setAttribute('depth', '0.01');
        handle.setAttribute('radius', '0.025');
        handle.setAttribute('color', '#7676E3');
        handle.setAttribute('opacity', '0.5');
        handle.setAttribute('position', '0.325 1.52 0.02');
        handle.setAttribute('scale', '1 1 1');
        handle.setAttribute('drag-move', 'target: #news-graph-legend-vr');
        if (isRepositioning) {
            handle.setAttribute('visible', 'true');
            handle.setAttribute('data-raycastable', '');
        } else {
            handle.setAttribute('visible', 'false');
        }
        bg.appendChild(handle);
    }
});

export function mountLegendPanel() {
    let legendPanel = document.getElementById('news-graph-legend-vr');
    if (!legendPanel) {
        legendPanel = document.createElement('a-entity');
        legendPanel.setAttribute('id', 'news-graph-legend-vr');
        legendPanel.setAttribute('news-graph-legend-vr', '');
        legendPanel.setAttribute('class', 'billboard-y');
        
        let initialPos = '2.420 2.80 -1.9';
        let initialRot = '0 0 0';
        if (typeof getCacheItem === 'function') {
            const savedPositions = getCacheItem('userPanelPositions');
            if (savedPositions && savedPositions.legendPanel) {
                if (savedPositions.legendPanel.position) initialPos = savedPositions.legendPanel.position;
                if (savedPositions.legendPanel.rotation) initialRot = savedPositions.legendPanel.rotation;
            }
        }
        legendPanel.setAttribute('position', initialPos);
        legendPanel.setAttribute('rotation', initialRot);
        
        const rightBanner = document.getElementById('right-banner');
        if (rightBanner && rightBanner.parentNode) {
            rightBanner.parentNode.appendChild(legendPanel);
        } else {
            const scene = document.querySelector('a-scene');
            if (scene) scene.appendChild(legendPanel);
        }
    }
}
